<template >
    <div :class="'slide-box ' + ('cur_'+cur_idx)">
        <div :class="'slider to-l ' + (cur_idx==0?'disabled':'')" @click="to_left"><img :src='left_pic' /></div>
        <div :class="'slider to-r'" @click="to_right"><img :src='right_pic' /></div>
        <div class="speaker-box">
            <img class="speaker" :src="speaker"  @click="play"/>
            <video class="cur-video" :src="list[cur_idx].voice" controls autoplay> </video>
        </div>
        <div 
            v-for="item,idx in list"
            :class="'slide-card '+ slide_status(idx) + (' idx_' + idx)"
        >
           
            <img :src="item.pic" :alt="item.title" >
            <video :src="item.voice" controls >

            </video>
           
        </div>

        <div class="indicator">{{cur_idx+1 }}/{{ list.length }}</div>
        <div class="skip" title="跳过" @click="skip">↷</div>
    </div>

     
</template>

<script>

import pic1 from "~pic/theory/计算界面-引导图片1.png"
import pic2 from "~pic/theory/计算界面-引导图片2.png"
import pic3 from "~pic/theory/计算界面-引导图片3.png"
import pic4 from "~pic/theory/计算界面-引导图片4.png"
import pic5 from "~pic/theory/计算界面-引导图片5.png"
import pic6 from "~pic/theory/计算界面-引导图片6.png"


import left_pic from "~pic/theory/向左箭头.png"
import right_pic from "~pic/theory/向右箭头.png"

import speaker from "~pic/speaker.png"
const video_src = [
    "video/计算界面-引导图片1.mp4",
    "video/计算界面-引导图片2.mp4",
    "video/计算界面-引导图片3.mp4",
    "video/计算界面-引导图片4.mp4",
    "video/计算界面-引导图片5.mp4",
    "video/计算界面-引导图片6.mp4",
];

export default ({
    name:'CaculatorGuide',
    data(){
        return {
            left_pic,right_pic,speaker,
            list:[
                {title:'pic1',pic:pic1,voice:video_src[0]},
                {title:'pic2',pic:pic2,voice:video_src[1]},
                {title:'pic3',pic:pic3,voice:video_src[2]},
                {title:'pic4',pic:pic4,voice:video_src[3]},
                {title:'pic5',pic:pic5,voice:video_src[4]},
                {title:'pic6',pic:pic6,voice:video_src[5]},
            ],
            cur_idx:0,
            play_idx:undefined,
            
        }
    },
    watch:{
        cur_idx:function(n_v,o_v){
            console.log('cur_idx changed to ',n_v);
            this.$emit('chg_idx',n_v);
        }
    },
    methods:{
        skip(){
            this.$emit('skip','CaculatorGuide');
        },
        slide_status(idx){
            if(idx===this.cur_idx)return 'cur ani-right';
            if(idx===this.cur_idx-1)return 'pre';
            if(idx===this.cur_idx+1)return 'after';
            return 'back'
        },
        to_left(){
            this.cur_idx--;
            if(this.cur_idx<0)this.cur_idx = 0;
            console.log(this.cur_idx);
        },
        to_right(){
            this.cur_idx ++;
            if(this.cur_idx>this.list.length-1){
                this.cur_idx = this.list.length-1;
                this.$emit('guide_over','CaculatorGuide');
            };
            console.log(this.cur_idx);
        },
        play(){
            // const doms = document.querySelectorAll(".slide-card video");
            const cur_dom = document.querySelector(".speaker-box video");//doms[this.cur_idx];
            if(cur_dom.paused){
                cur_dom.play()
            }else{
                cur_dom.pause();
            }
            // cur_dom.play();

        },

    }
})
</script>

<style lang="stylus" scoped>
p
    font-size:smaller;
    text-indent: 2em

h3
    margin-top:1em;

.slide-box{
    position:relative;
    max-width:100%;
    overflow:hidden;
    padding:10em 1em;
    transition:all 0.5s;
}
.slide-card{
    width:100%;
    display:inline-flex;
    align-items:center;
    justify-content:center;
}
.slide-card img{
    width:75%;
}
.slide-card.back{display:none;}
.slide-card.cur.ani-right{
    width:unset;
    transition:width 1s;
}
.slide-card.pre{
    width:0px;
}
.slide-card.after{
    width:0px;
}

.slide-card video{
    position:absolute;
    left:50px;
    top:100px;
    width:1px;
    height:1px;
}
.slide-box .speaker-box{
    position:absolute;
    left:140px;
    top:160px;
    width:30px;
    height:30px;
}
.speaker-box video{
    display:none;
}
.speaker-box:hover{
    filter:drop-shadow(2px 4px 6px black)
}

.slider,.skip {
    position:absolute;
    height:80px;
    width:80px;
    //top:50%;
    bottom:18%;
    left:50%;
    transform:translateX(-50%);
    cursor:pointer;
}
.slider img{
    width:100%;
    height:100%;
}


.skip{
    transform:translate(calc(-50% + 150px),20px)
}
.skip:hover{color:green;}
.slider.to-l{transform:translateX(calc(-50% - 150px))}
.slider.to-r{transform:translateX(calc(-50% + 50px))}

.slider:hover{
   // border:1px solid green;
   // background-color:green;
   filter:drop-shadow(2px 4px 6px black);
    border-radius:40%;
}
.slider.disabled{
    filter:grayScale(1);
}

.indicator{
    position:absolute;
    right:2px;
    bottom:10px;
}

/*最后一张特殊处理*/
.slide-box.cur_3{
    transform:scale(0.80) translate(163px, 96px);
}
.slide-box.cur_3 *{
    pointer-events:auto;
}
.slide-box.cur_4{
    transform:scale(0.80) translate(163px, -56px);
}
.slide-box.cur_4 *{
    pointer-events:auto;
}

</style>
